export default "__VITE_ASSET__DhP5OkXs__"